import { render, staticRenderFns } from "./PendingDeliveryReceipts.vue?vue&type=template&id=35d332c2&scoped=true&"
import script from "./PendingDeliveryReceipts.vue?vue&type=script&lang=js&"
export * from "./PendingDeliveryReceipts.vue?vue&type=script&lang=js&"
import style0 from "./PendingDeliveryReceipts.vue?vue&type=style&index=0&id=35d332c2&prod&lang=scss&scoped=true&"
import style1 from "./PendingDeliveryReceipts.vue?vue&type=style&index=1&id=35d332c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d332c2",
  null
  
)

export default component.exports